<template functional>
  <div
    class="chat-cell"
    :class="{'chat-cell--condensed': props.condensed}"
  >
    <div class="chat-cell__author">
      {{ props.author.replace(/\[.*\]/, '') }}
    </div>
    <div class="chat-cell__message">
      {{ props.message }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatCell',
};
</script>

<style lang="scss" scoped>
.chat-cell{
    max-width: 380px;
    width: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
    // pointer-events: none;
    text-rendering: geometricPrecision;
    color:white;
    text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
    &--condensed {
      padding-left: 0px;
      padding-right: 0px;
    }
    & + & {
        margin-top: 12px;
    }

    &__author{
        font-family: $font-family-sans-serif-bold;
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 4px;
    }
    &__message{
        font-family: $font-family-sans-serif-medium;
        font-size: 12px;
        line-height: 16px;
    }
}

</style>
